import { Intangible } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { HotelViewModel } from '@api/models/HotelViewModel';
import useGetAsPath from '@hooks/useGetAsPath';

export const HotelListSchemaOrg = ({
  name,
  hotels,
}: {
  name: string;
  hotels: HotelViewModel[][];
}) => {
  const path = useGetAsPath();
  const url = `${process.env.NEXT_PUBLIC_HOST}${path}`;

  return (
    <Script
      defer
      {...jsonLdScriptProps<Intangible>({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: name,
        url,
        itemListElement: hotels?.[0]?.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Hotel',
            name: item?.name,
            url: `${process.env.NEXT_PUBLIC_HOST}/otel/${item.url || ''}`,
            image: item?.image,
            aggregateRating:
              item?.ratings?.rating?.value &&
              item?.ratings?.rating?.totalReviewCount
                ? {
                    '@type': 'AggregateRating',
                    reviewCount: item?.ratings?.rating?.totalReviewCount,
                    ratingValue: Number(item?.ratings?.rating?.value),
                    bestRating: 5,
                    worstRating: 1,
                  }
                : undefined,
            address: item.location
              ? {
                  '@type': 'PostalAddress',
                  addressLocality: item?.location,
                }
              : undefined,
          },
        })),
      })}
    />
  );
};
